/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleDiagnosticsControllerLookupEmsEntitlementQueryResponse, TrimbleDiagnosticsControllerLookupEmsEntitlementPathParams, TrimbleDiagnosticsControllerLookupEmsEntitlement400, TrimbleDiagnosticsControllerLookupEmsEntitlement401, TrimbleDiagnosticsControllerLookupEmsEntitlement403, TrimbleDiagnosticsControllerLookupEmsEntitlement404 } from "../../models/trimbleDiagnosticsController/TrimbleDiagnosticsControllerLookupEmsEntitlement";

function getTrimbleDiagnosticsControllerLookupEmsEntitlementUrl(cdhAccountId: TrimbleDiagnosticsControllerLookupEmsEntitlementPathParams["cdhAccountId"]) {
  const res = { method: 'GET', url: `/api/v1/trimble-ems-diagnostics/${cdhAccountId}` as const }  
  return res
}

/**
 * @summary Check the EMS entitlement for a Trimble CDH account
 * {@link /api/v1/trimble-ems-diagnostics/:cdhAccountId}
 */
export async function trimbleDiagnosticsControllerLookupEmsEntitlement(cdhAccountId: TrimbleDiagnosticsControllerLookupEmsEntitlementPathParams["cdhAccountId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrimbleDiagnosticsControllerLookupEmsEntitlementQueryResponse, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupEmsEntitlement400 | TrimbleDiagnosticsControllerLookupEmsEntitlement401 | TrimbleDiagnosticsControllerLookupEmsEntitlement403 | TrimbleDiagnosticsControllerLookupEmsEntitlement404>, unknown>({ method : "GET", url : getTrimbleDiagnosticsControllerLookupEmsEntitlementUrl(cdhAccountId).url.toString(), ... requestConfig })  
  return res.data
}